export default {
	es: {

		enlaces: {
			contacto: "/contacto",
			tutores: "/servicios/tutores",
			titulados: "/servicios/titulados",
			empresas: "/servicios/empresas",
			colaboradores: "/colaboradores",
			programasyofertas : '/programas-y-ofertas',
			faqs: "/faqs",
			cookies: '/politica-de-cookies',
			avisolegal: '/aviso-legal',
			politicaprivacidad: '/politica-de-privacidad'
		},
		portalalumno : 'https://portal.uvaempleo.com/login',
		portalalumnoregistro : 'https://portal.uvaempleo.com/registro',
		portalempresas : 'https://portal.uvaempleo.com/login/empresas',
		portalempresasregistro : 'https://portal.uvaempleo.com/solicitar-cuenta',
		portaltutores  : 'https://tutor.uvaempleo.com/'
	},
	en: {
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js